import { render, staticRenderFns } from "./column-config.vue?vue&type=template&id=dcb755dc"
import script from "./column-config.vue?vue&type=script&lang=js"
export * from "./column-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports